import { render, staticRenderFns } from "./editarPagina.vue?vue&type=template&id=7c63b3aa&scoped=true"
import script from "./editarPagina.vue?vue&type=script&lang=js"
export * from "./editarPagina.vue?vue&type=script&lang=js"
import style0 from "./editarPagina.vue?vue&type=style&index=0&id=7c63b3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63b3aa",
  null
  
)

export default component.exports